// extracted by mini-css-extract-plugin
export default {"cls1":"M7qI6MrPhjsRUMXbKXbb","cls2":"EdvDXgbXXneUzTGQcOMG M7qI6MrPhjsRUMXbKXbb","isTabletUp":"fk28i1drZVnuZ0WPDiPV"};